import React from 'react'

import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'

const form = props => {

  let [key, attr] = props.form
 
    return (
      <InputGroup
        key={key}
        label={attr.label}
        inputType={attr.elementType}
        configs={attr.elementConfig}
        invalid={!attr.valid}
        validations={attr.validation}
        touched={attr.touched}
        changed={e => props.inputChanged(key, e)}
        inputValue={attr.value}
        validationError={attr.error}
      />
    )
  
}

export default form
